// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._19pkutpp{margin-top:var(--ds-space-150,9pt)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._1tkeys9h{min-height:5pc}\n._1wpz1h6o{align-self:center}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
